<template>
    <div>
        <div class="d-md-inline-block">
            <v-checkbox
                :readonly="!item.canEdit"
                :hideCbx="!item.canEdit"
                :checked="item.isAccepted"
                :htmlId="'Agreement_isAccepted_' + index"
                :itemIndex="index"
                :label="item.title" />
        </div>
        <button @click="isVisible = !isVisible" class="ml-md-button" type="button">Pełna treść klauzuli</button>
        <transition name="slide-up">
            <div v-if="isVisible" class="agreement-full">{{ item.content }}</div>
        </transition>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isVisible: false
        };
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    }
};
</script>